import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessibilityService } from '../../../services/accessibility.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-accessibility-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accessibility-panel.component.html',
  styleUrl: './accessibility-panel.component.scss',
})
export class AccessibilityPanelComponent implements OnInit, OnDestroy {
  @Input() isOpen: boolean = false;
  @Output() closePanel = new EventEmitter<void>();
  
  settings: any = {};
  private subscription?: Subscription;

  constructor(private accessibilityService: AccessibilityService) {}

  ngOnInit(): void {
    this.subscription = this.accessibilityService.settings$.subscribe(
      (settings: any) => {
        this.settings = settings;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  togglePanel(): void {
    if (this.isOpen) {
      this.close();
    } else {
      this.isOpen = true;
    }
  }

  close(): void {
    this.isOpen = false;
    this.closePanel.emit();
  }

  get canIncreaseText(): boolean {
    const v = Number(this.settings?.textSize ?? 1);
    return v < 1.2;
  }

  get canDecreaseText(): boolean {
    const v = Number(this.settings?.textSize ?? 1);
    return v > 0.8;
  }

  increaseText(): void {
    this.accessibilityService.increaseText();
  }

  decreaseText(): void {
    this.accessibilityService.decreaseText();
  }

  toggleGrayscale(): void {
    this.accessibilityService.toggleGrayscale();
  }

  toggleHighContrast(): void {
    this.accessibilityService.toggleHighContrast();
  }

  toggleNegativeContrast(): void {
    this.accessibilityService.toggleNegativeContrast();
  }

  toggleLightBackground(): void {
    this.accessibilityService.toggleLightBackground();
  }

  toggleLinksUnderline(): void {
    this.accessibilityService.toggleLinksUnderline();
  }

  toggleReadableFont(): void {
    this.accessibilityService.toggleReadableFont();
  }

  reset(): void {
    this.accessibilityService.reset();
  }
}

